const B2BTheme = () => {
  return {
    Favorite: {
      themeProps: {
        hideCount: true,
        showOverlay: true,
        showPlusSign: true
      }
    },
    ListFormsSettingsForm: {
      themeProps: {
        showShareList: true,
        hidePrivacyToggle: true
      }
    },
    ProductListHeader: {
      themeProps: {
        hideActionButtons: true,
      }
    },
    ProductListHeaderMobile: {
      themeProps: {
        showATC: true,
      }
    },
    ListTileMobile: {
      themeProps: {
        showShareList: true,
      }
    },
    CreateAListForm: {
      themeProps: {
        showShareList: true,
        hidePrivacyToggle: true
      }
    },
    PackagePriceSuite: {
      themeProps: {
        hideFinancingOffer: true
      }
    },
    ProductInfoBar: {
      themeProps: {
        showUpcCode: true
      }
    },
    ProductList: {
      themeProps: {
        showListView: true,
        showATQ: true,
        showSaveSharedListBanner: true
      }
    },
    ProductListNotFoundMessaging: {
      themeProps: {
        showPlusSign: true
      }
    },
    ProductListEmptyListMessaging: {
      themeProps: {
        showPlusSign: true
      }
    },
    ProductOverview: {
      themeProps: {
        showUpcCode: true
      }
    },
    ProductPod: {
      themeProps: {
        showModelNumber: true,
        showSkuNumber: true,
      }
    },
    ProductPodDefault: {
      themeProps: {
        showModelNumber: true,
        showSkuNumber: true,
      }
    },
    UserListsEmptyMessaging: {
      themeProps: {
        showPlusSign: true
      }
    },
    UserListsEmptyMessagingPhp: {
      themeProps: {
        showListIcon: true
      }
    }
  }
};

export default B2BTheme;
